import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Icon } from "../../icons";

function SidebarItem({
  icon,
  label,
  onClick,
  active = false,
  disabled = false,
  title = "",
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={`flex w-full flex-col items-center rounded-xl px-2 py-2 transition-all duration-200 ${
        disabled
          ? "cursor-not-allowed text-slate-600"
          :
        active
          ? "bg-indigo-500/10 text-indigo-300"
          : "text-slate-400 hover:bg-slate-800/50 hover:text-indigo-300"
      }`}
    >
      <Icon name={icon} style={{ width: 22, height: 22 }} />
      <span className="mt-1 text-[11px] font-bold tracking-tight">{label}</span>
    </button>
  );
}

export default function SVSidebar({
  handleLogout,
  onOpenSimulationSettings,
  isSimulationSettingsOpen = false,
  onOpenResultPopup,
  isResultPopupOpen = false,
}) {
  const navigate = useNavigate();
  const { group_code, project_code } = useParams();
  const isSimulationFeatureEnabled =
    group_code === "demo" && project_code === "ese";
  const simulationDisabledMessage = isSimulationFeatureEnabled
    ? ""
    : "demo / ese 프로젝트에서만 사용할 수 있습니다.";

  const handleHome = () => {
    navigate("/projects");
  };

  const handleOpenSimulationSettings = () => {
    if (onOpenSimulationSettings) {
      onOpenSimulationSettings();
    }
  };

  const handleOpenResultPopup = () => {
    if (onOpenResultPopup) {
      onOpenResultPopup();
    }
  };

  return (
    <div className="z-50 flex h-full w-[80px] flex-col border-r border-slate-800 bg-slate-900 shadow-2xl">
      <div className="flex h-20 items-center justify-center border-b border-slate-800/50">
        <img src="/images/ese_logo.png" alt="Logo" className="w-10 opacity-90" />
      </div>

      <div className="flex-1 overflow-y-auto px-2 py-3 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-slate-700 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar]:w-1">
        <div className="mb-6">
          <div className="mb-2 text-center text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500">
            이동
          </div>
          <SidebarItem icon="homeIcon" label="홈" onClick={handleHome} />
        </div>

        <div>
          <div className="mb-2 text-center text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500">
            시뮬레이션
          </div>
          <SidebarItem
            icon="monitorIcon"
            label="시뮬레이션"
            active={isSimulationSettingsOpen}
            onClick={handleOpenSimulationSettings}
            disabled={!isSimulationFeatureEnabled}
            title={simulationDisabledMessage}
          />

          <SidebarItem
            icon="chartIcon"
            label="결과확인"
            active={isResultPopupOpen}
            onClick={handleOpenResultPopup}
            disabled={!isSimulationFeatureEnabled}
            title={simulationDisabledMessage}
          />
        </div>
      </div>

      <div className="border-t border-slate-800 bg-slate-900/50 py-4">
        <div className="flex justify-center">
          <button
            type="button"
            onClick={handleLogout}
            className="group flex flex-col items-center text-slate-500 transition-colors hover:text-red-400"
            title="Logout"
          >
            <Icon name="logoutIcon" style={{ width: 24, height: 24 }} />
            <span className="mt-1 text-[11px] font-bold">로그아웃</span>
          </button>
        </div>
      </div>
    </div>
  );
}
